import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyCode } from './currency-code.pipe';
import { LimitLength } from './limit-length.pipe';
import { StringobjectPipe } from './stringobject.pipe';
import { TranslationFormatPipe } from './translation-format.pipe';
import { FormatPhoneNumberPipe } from './format-phone-number.pipe';
import { ReplaceSeparatorAndCapitalizePipe } from './replace-separator-and-capitalize.pipe';
import { FormatNumberBasedOnCurrencyPipe } from './format-number-based-on-currency.pipe';
import { CustomDatePipe } from './custom-date.pipe';
import { TrustedUrl } from './trusted-url.pipe';
import { TrustedHtml } from './trusted-html.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';
import { LinkPipe } from './link.pipe';
import { IbanFormatPipe } from './iban-format.pipe';
import { PropertyByLangPipe } from './property-by-lang.pipe';
import { FormatCode } from './format-code.pipe';
import {RtlWordReorderPipe } from './rtl-word-reorder.pipe';
const pipes:any[] = [
  CurrencyCode,
  LimitLength,
  StringobjectPipe,
  TranslationFormatPipe,
  ReplaceSeparatorAndCapitalizePipe,
  FormatNumberBasedOnCurrencyPipe,
  CustomDatePipe,
  TrustedHtml,
  TrustedUrl,
  PhoneNumberPipe,
  LinkPipe,
  FormatPhoneNumberPipe,
  PropertyByLangPipe,
  IbanFormatPipe,
  FormatCode,
  RtlWordReorderPipe
];

@NgModule({
  declarations: [
    ...pipes
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    ...pipes,
  ],
  providers: [
    ...pipes
  ]
})
export class CommonPipesModule { }
